import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material';

@Component({
  selector: 'app-user-policy',
  templateUrl: './user-policy.component.html',
  styleUrls: ['./user-policy.component.css']
})
export class UserPolicyComponent implements OnInit {
  isFullOpenName = '規約をすべて見る';
  isFullOpen = false;

  items = [];

  @ViewChild('myaccordion') myPanels: MatAccordion;

  allOpenClose() {
    if (this.isFullOpen) {
      this.myPanels.closeAll();
      this.isFullOpen = !this.isFullOpen;
      this.isFullOpenName = '規約をすべて見る';
    } else {
      this.myPanels.openAll();
      this.isFullOpen = !this.isFullOpen;
      this.isFullOpenName = 'すべて閉じる';
    }
  }

  ngOnInit() {
    this.getUserPolicy().then(res => {
      return res.json();
    }).then(data => {
      const userPolicy = data.UserPolicy.find( x=> parseInt(x.id) === 1);
      if(userPolicy) {
        this.items = userPolicy.detail.map( x => {
          x.data = x.data.split('\r\n').map( x => x.trim()).join('<br />')
          return x;
        });
      }
    });
  }

  async getUserPolicy() {
    return await fetch('https://ain-mobile-app-info.s3-ap-northeast-1.amazonaws.com/userPolicy.json');
  }
}

